import $ from "jquery";

const SubscribeEmail = () => {
	function init() {
		handleSubscribeButton();
		handleOnChange();
	}

	function handleOnChange() {
		$(".js-footer-input").on("input", function () {
			if ($(this).val() !== "") {
				$(".js-form-error").html("");
			}
		});
		$(".js-sub-input-modal").on("input", function () {
			if ($(this).val() !== "") {
				$(".js-form-error-modal").html("");
			}
		});
	}

	function handleSubscribeButton() {
		$(document).on("click", ".js-subscribe-btn", function (e) {
			e.preventDefault();
			let $e = $(this);
			let $selector = $($e.data("input"));
			let $errorSelector = $($e.data("error"));
			let inputValue = $selector.val();
			let isValidEmail = validateEmail(inputValue);
			$e.attr("disabled", true);
			if (isValidEmail) {
				console.log(inputValue);
				$selector.val("");
				$e.children("img").attr("src", "/wp-content/themes/health-hub/dist/images/icons/oval.svg");
				handleRequest(inputValue, $errorSelector, $e);
			} else {
				console.log("not valid");
				$e.attr("disabled", false);
				$errorSelector.html("<p class='footer-form__error'>Please enter a valid email address</p>");
			}
		});
	}

	function handleRequest(email, $errorSelector, $e) {
		fetch(`/wp-json/h-h/v1/input-email/${email}`)
			.then((response) => {
				$e.children("img").attr("src", "/wp-content/themes/health-hub/dist/images/icons/subscribe-white.svg");
				$e.attr("disabled", false);
				if (response.ok) {
					return response.json();
				}
				throw new Error("Something went wrong");
			})
			.then((responseJson) => {
				// Do something with the response
				if (responseJson.results == true) {
					$errorSelector.html("<p class='footer-form__error'>" + responseJson.confirmation_message + "</p>");
				}
			})
			.catch((error) => {
				console.log(error);
				$errorSelector.html("<p class='footer-form__error'>There was an issue with your request. Try again!</p>");
			});
	}

	function validateEmail(email) {
		return email.match(
			/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
		);
	}

	init();
};

export default SubscribeEmail;
